// extracted by mini-css-extract-plugin
export var colorSquare = "_qr-0";
export var danger = "_qr-5";
export var lightPink = "_qr-8";
export var neutralBlue = "_qr-7";
export var neutralYellow = "_qr-6";
export var normal = "_qr-1";
export var primary = "_qr-2";
export var primaryLight = "_qr-3";
export var solidBlack = "_qr-g";
export var solidGreen = "_qr-b";
export var solidLightBlue = "_qr-d";
export var solidNavy = "_qr-c";
export var solidOrange = "_qr-f";
export var solidPink = "_qr-e";
export var solidRed = "_qr-9";
export var solidYellow = "_qr-a";
export var success = "_qr-4";